import { jsxs as t, jsx as r } from "react/jsx-runtime";
const i = ({ className: o }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o,
    children: [
      /* @__PURE__ */ t("g", { clipPath: "url(#clip0_387_16202)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            d: "M1.33203 7.6C1.33203 6.82782 1.49319 6.66666 2.26536 6.66666H13.732C14.5042 6.66666 14.6654 6.82782 14.6654 7.6V8.4C14.6654 9.17218 14.5042 9.33333 13.732 9.33333H2.26536C1.49319 9.33333 1.33203 9.17218 1.33203 8.4V7.6Z",
            stroke: "currentColor",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M1.33203 2.26667C1.33203 1.49449 1.49319 1.33334 2.26536 1.33334H13.732C14.5042 1.33334 14.6654 1.49449 14.6654 2.26667V3.06667C14.6654 3.83885 14.5042 4 13.732 4H2.26536C1.49319 4 1.33203 3.83885 1.33203 3.06667V2.26667Z",
            stroke: "currentColor",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M1.33203 12.9333C1.33203 12.1612 1.49319 12 2.26536 12H13.732C14.5042 12 14.6654 12.1612 14.6654 12.9333V13.7333C14.6654 14.5055 14.5042 14.6667 13.732 14.6667H2.26536C1.49319 14.6667 1.33203 14.5055 1.33203 13.7333V12.9333Z",
            stroke: "currentColor",
            strokeLinecap: "round"
          }
        )
      ] }),
      /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ r("clipPath", { id: "clip0_387_16202", children: /* @__PURE__ */ r("rect", { width: "16", height: "16", fill: "currentColor" }) }) })
    ]
  }
);
export {
  i as ListIcon
};
